module.exports = __webpack_public_path__ + "media/images/brands/marque-manucurist@2x-91bfeada059db8312b217f961be92cf9.jpg";